import PricingPlan from 'components/modules/PricingPlan/PricingPlan'
import React from 'react'

const ManagePlansPage = () => {
    return (
        <>
            <PricingPlan />
        </>
    )
}

export default ManagePlansPage
